export default {
  TOKEN_EXPIRED: 1004,
  INVALIDATE_TOKEN: 1005,
  UNAUTHORIZED_WIW_ID: 1006,
  UNBOUND_WIW_ID: 1007
};
